import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.tr`
  /* @media (max-width: 600px), (min-width: 768px) and (max-width: 940px) {
    ${tw`flex flex-wrap w-full`};

    td {
      ${tw`flex items-center`};
    }

    td.cell-quantity {
      ${tw`justify-center w-auto`};
      width: 140px;
    }

    td.cell-subtotal {
      ${tw`pl-4 flex-grow`};
    }

    td:first-child {
      padding-bottom: 0;
      border-bottom: 0;
    }
  } */
`

export const ProductCell = styled.td`
  ${tw`pr-4`};
`

export const QuantityCell = styled.td`
  ${tw`w-px text-center whitespace-nowrap`};
  ${({ $fetching }) => $fetching && tw`opacity-50 pointer-events-none cursor-wait`};
`

export const PriceCell = styled.td`
  ${tw`pl-6 whitespace-nowrap`};
  ${({ $fetching }) => $fetching && tw`opacity-50 pointer-events-none cursor-wait`};

  * {
    ${tw`block`};
  }
`

export const QuantityButtons = styled.div`
  ${tw`inline-block border-b`};
  border-color: var(--color-black);
`

export const QuantityDecrementButton = styled.button`
  ${tw`pr-2`};
`

export const QuantityIncrementButton = styled.button`
  ${tw`pl-2`};
`
